module.exports = __webpack_public_path__ + "img/user_white.e9c2a228.png";